import React from 'react';

export const Home = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      d="M0.809082 7.66669V7.50002L8.14242 0.900024L15.4757 7.50002V7.66669H14.8091V14.6667H1.47575V7.66669H0.809082Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
